import { styled } from "@mui/material/styles";
import { ListItemIcon, ListItemButton } from "@mui/material";

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => {
  const { isActive, ...otherProps } = props; // Get `isActive` prop to check active state
  return (
    <ListItemButton
      className={isActive ? "active" : ""}
      disableGutters
      {...otherProps}
    />
  );
})(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  margin: "3px 0px",
  position: "relative",
  textTransform: "capitalize",
  color: "#ffffff", // Change text color
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#1c1c1c", // Sidebar background color
  // backgroundColor: "#1e1e2d", // Sidebar background color
  "&:hover": {
    backgroundColor: "#393939", // Hover background color
    // backgroundColor: "#303050", // Hover background color
  },
  "&.active": {
    color: "#ffcc00", // Active item text color
    backgroundColor: "red", // Active item background color
    fontWeight: theme.typography.fontWeightBold,
  },
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 22,
  height: 22,
  color: "#ffffff", // Change icon color
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
